module.exports = __webpack_public_path__ + "img/golfoffice-laying.ade8cef8.svg";